import { ActionType } from 'typesafe-actions';
import { combineReducers } from 'redux';
import {
  SET_DOCUMENTS_ASSIGNED_TO_ME_COUNT,
  SET_PROJECT,
  UPDATE_PHYSICAL_LOCATIONS,
  UPDATE_PROJECT,
} from './constants';
import * as projectActions from './actions';
import { Project } from './project';
import { DocumentTypeCount } from '../../models/api/notifications';

export type ProjectAction = ActionType<typeof projectActions>;
export type ProjectState = { project: Project; documentsAssignedToMeCount: DocumentTypeCount[] };

export default combineReducers<ProjectState, ProjectAction>({
  project: (state = null, action) => {
    let newState: Project = null;
    switch (action.type) {
      case SET_PROJECT:
        newState = action.payload;
        break;
      case UPDATE_PROJECT:
        if (state) newState = { ...state, ...action.payload };
        break;
      case UPDATE_PHYSICAL_LOCATIONS:
        if (state) newState = { ...state, physicalBuildings: action.payload };
        break;
      default:
        newState = state;
    }
    return newState;
  },
  documentsAssignedToMeCount: (state = [], action) => {
    let newState: DocumentTypeCount[] = [];
    switch (action.type) {
      case SET_DOCUMENTS_ASSIGNED_TO_ME_COUNT:
        newState = action.payload;
        break;
      default:
        newState = state;
        break;
    }
    return newState;
  },
});
